<template>
  <v-container>
    <v-layout row class="text-xs-center">
        <v-container style="position: relative;top: 13%;" class="text-xs-center">
              <h1>Login</h1>
              <pre><p id="colorRed">Could not find your credentials</p></pre>
                <v-btn color="primary" @click="handleLogin()"><v-icon>mdi-account-circle</v-icon>Individual Login</v-btn>
                <v-btn color="primary" @click="handleWorkerLogin()"> Worker Login</v-btn>
                <pre><span>Don't already have an account? <router-link to="/register">Get a DID here</router-link> </span></pre>
    </v-container>
    </v-layout>
  </v-container>
</template>

<script>
import EosService from '@/eosio/EosService';

export default {
  data() {
    return {
      email: '',
      orgName: '',
      license: '',
      defaultDidContract: process.env.VUE_APP_ISSUEDID_CONTRACT_NAME,
      defaultHealthWorkerContract: process.env.VUE_APP_HEALTHWORKER_CONTRACT_NAME,
      eosio: null
    };
  },
  methods: {
    handleLogin: async function() {
      if (this.eosio === null) {
        this.eosio = new EosService(
          process.env.VUE_APP_ISSUEDID_NAME,
          process.env.VUE_APP_ISSUEDID_CONTRACT_NAME
        );
      }

      if (!(await this.eosio.connect()))
        return console.log('Failed to get Scatter account');

      try{
        let status=await this.eosio.getLogin(this.eosio.account.name,this.defaultDidContract);
        if(status){
          this.$store.commit('loginStatus', true);
          this.$store.commit('Identity','individual');
          
          this.$router.push('individual');
        }
        else {
          document.querySelector('#colorRed').style.display="inline";
        }
      }catch(error){
        console.log(error);
      }
    },
    handleWorkerLogin: async function() {
      if (this.eosio === null) {
        this.eosio = new EosService(
          process.env.VUE_APP_ISSUEDID_NAME,
          process.env.VUE_APP_ISSUEDID_CONTRACT_NAME
        );
      }

      if (!(await this.eosio.connect()))
        return console.log('Failed to get Scatter account');

      try{
        let status=await this.eosio.getLogin(this.eosio.account.name,this.defaultHealthWorkerContract);
        if(status) {
          this.$store.commit('loginStatus', true);
          this.$store.commit('Identity','worker');
          
          this.$router.push('workerview');
        }
        else {
          document.querySelector('#colorRed').style.display="inline";
        }
      }catch(error){
        console.log(error);
      }
    }
  }
};
</script>

<style scoped>
  .v-btn{
    color:primary;
  }
</style>